import React, { useEffect, useState } from "react";
import CrudPage from "@/components/CrudPage";
import { providersApi, companiesApi } from "@/lib/orgApi";

const ProvidersPage = () => {
    const [companies, setCompanies] = useState([]);
    useEffect(() => {
        companiesApi.list().then(setCompanies).catch(() => setCompanies([]));
    }, []);

    return (
        <CrudPage
            title="Providers"
            subtitle="DD/IDD service providers that operate group homes."
            api={providersApi}
            testidPrefix="providers"
            columns={[
                { key: "name", label: "Name" },
                {
                    key: "company_id",
                    label: "Company",
                    render: (r) =>
                        companies.find((c) => c.id === r.company_id)?.name ||
                        "—",
                },
                { key: "phone", label: "Phone" },
                {
                    key: "active",
                    label: "Status",
                    render: (r) =>
                        r.active ? (
                            <span className="rounded-full bg-brand-green-100 px-2.5 py-1 text-xs font-semibold text-brand-green-800">
                                Active
                            </span>
                        ) : (
                            <span className="rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600">
                                Inactive
                            </span>
                        ),
                },
            ]}
            fields={[
                {
                    name: "company_id",
                    label: "Company",
                    type: "select",
                    required: true,
                    options: companies.map((c) => ({
                        value: c.id,
                        label: c.name,
                    })),
                },
                { name: "name", label: "Provider name", required: true },
                { name: "tax_id", label: "Tax ID" },
                { name: "address", label: "Address" },
                { name: "phone", label: "Phone" },
                {
                    name: "active",
                    label: "Active",
                    type: "boolean",
                    default: true,
                },
            ]}
        />
    );
};

export default ProvidersPage;
